<template>
  <ConfirmationModal
    confirmColor="danger"
    modalTestID="remove-approval-modal"
    :persistent="false"
    :show="show"
    :isLoading="isRemovingApproval"
    :title="$t('routines.approval.remove_approval_title')"
    :text="$t('routines.approval.remove_approval_message')"
    :confirmText="$t('common.remove')"
    :cancelText="$t('common.button.cancel')"
    @cancel="$emit('close')"
    @confirm="removeApproval"
    @close="$emit('close')"
  />
</template>
<script>
import ConfirmationModal from '@/components/Modals/ConfirmationModal.vue'

import mixin from '@/mixins/mixin.vue'
import api from '@/api'

import { mapGetters } from 'vuex'

export default {
  name: 'RoutineApprovalDialog',

  mixins: [mixin],

  props: {
    show: Boolean,
    approvalId: { type: String },
    routineId: { type: String },
  },

  components: {
    ConfirmationModal,
  },

  data() {
    return {
      isRemovingApproval: false,
    }
  },

  computed: {
    ...mapGetters(['account', 'organizationId']),
  },

  methods: {
    async removeApproval() {
      try {
        if (!this.approvalId || !this.routineId) return
        this.isRemovingApproval = true
        await api.routine.removeRoutineApproval(
          this.organizationId,
          this.routineId,
          this.approvalId
        )
        this.showSuccess(
          this.$t('routines.approval.approval_removed_successfully')
        )
        this.$emit('success')
        this.$emit('close')
      } catch (err) {
        this.showError(this.$t('routines.approval.approval_removal_failed'))
      } finally {
        this.isRemovingApproval = false
      }
    },
  },
}
</script>
